import { findSubNode, getCustomisationValue } from "../../EditablePreview";
import VisualisedNode from "../VisualisedNode";
import { GET_ANIMOVERLAY_SETTINGS, getBgStyle, getTitlesContainerPositionStyle } from "./animated-overlay-helper";
import './animated-overlay.scss';

const AnimatedOverlay = (props) => {
    console.log('AnimatedOverlay props', props);
    const previewScale = props.previewScale || 1;
    const campaignData = props.campaignData;
    const animatedOverlayNode = props.node;
    const customisationVars = animatedOverlayNode.customisationVars;
    const settings = GET_ANIMOVERLAY_SETTINGS(customisationVars, campaignData);
    const logoImageData = getCustomisationValue(customisationVars, 'visual.campaignLogo.clientLogo.filename', 0);
    const titleImageData = getCustomisationValue(customisationVars, 'visual.campaignLogo.campaignLogo.filename', 0);
    const bgImageData = getCustomisationValue(customisationVars, 'visual.overlaySettings.bgPattern.filename', 0);

    return (
        <>
            <div style={getBgStyle(settings.displayOptions, bgImageData, previewScale)}></div>
            <div className="v2-animoverlay_animated-titles-container" style={getTitlesContainerPositionStyle(settings.displayOptions, previewScale)}>
                <div className='v2-animoverlay_grow'></div>
                <div className='v2-animoverlay_cell'>
                    <div className='v2-animoverlay_animated-title'>
                        <VisualisedNode {...props} node={findSubNode(props.node, 'Top Logo')}>
                            <img className='v2-animoverlay_animation-object' src={logoImageData.srcUrl} alt="" style={{transform: `scale(${settings.displayOptions.logoScale / 100})`}} />
                        </VisualisedNode>
                    </div>
                </div>
                <div className='v2-animoverlay_grow'></div>
                <div className='v2-animoverlay_cell'>
                    <div className='v2-animoverlay_animated-title'>
                        <VisualisedNode {...props} node={findSubNode(props.node, 'Bottom Logo')}>
                            <img className='v2-animoverlay_animation-object' src={titleImageData.srcUrl} alt="" style={{transform: `scale(${settings.displayOptions.titleScale / 100})`}} />
                        </VisualisedNode>
                    </div>
                </div>
                <div className='v2-animoverlay_grow'></div>

            </div>
        </>
    )
}

export default AnimatedOverlay;
